import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { allNodeEventFailed, allNodeEventSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* allNodeEvent(action) {
  try {
    const url = `${BACKEND_URL}/${action.payload ? 'unpause' : 'pause'}-all-nodes`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      yield put(allNodeEventSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(allNodeEventFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(allNodeEventFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
